import DotsLoading from 'components/loadings/dotsLoading'
import Item from './item'
import { CiSearch } from 'react-icons/ci'
interface ITransactionProps {
    data: IMoneyPoolTransaction | undefined
    isLoading: boolean
    isManager: boolean
    searchTrans: string
    setSearchtransaction: React.Dispatch<React.SetStateAction<string>>
    setSearchTrans: React.Dispatch<React.SetStateAction<string>>
}
export default function Transactions({
    data,
    isLoading,
    isManager,
    searchTrans,
    setSearchtransaction,
    setSearchTrans,
}: ITransactionProps) {
    return (
        <div>
            {!isLoading && data ? (
                <div className=" mx-4">
                    <div className="flex h-[25px]">
                        <input
                            type="text"
                            className=" w-full outline-0 border border-green-1 rounded-full px-2 py-1 ml-3"
                            onChange={(e) => setSearchTrans(e.target.value)}
                            value={searchTrans}
                            placeholder="جستجو..."
                        />
                        <CiSearch
                            className=" text-green-1  w-8 h-full cursor-pointer"
                            onClick={() => {
                                setSearchtransaction(searchTrans)
                            }}
                        />
                    </div>
                    {data.results.result.length === 0 ? (
                        <p className=" text-center">تراکنشی وجود ندارد</p>
                    ) : (
                        <>
                            {data.results.result.map((item) => (
                                <Item
                                    item={item}
                                    key={item.id}
                                    isManager={isManager}
                                />
                            ))}
                        </>
                    )}
                </div>
            ) : (
                <DotsLoading />
            )}
        </div>
    )
}
